import "./LoginPage.css"

import { useState } from "react";

export default function LoginPage({setIsLoggedIn, getUserInfo}) {

    const [login, setLogin] = useState(true);
    const [loading, setLoading] = useState(false);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");

    const [error, setError] = useState("");


    const logInFunc = async () => {

        if(loading) return;

        setLoading(true);

        const route = login ? "/auth" : "/user/signup";


        const obj = {name, email, password};

        try {

            const response = await fetch(process.env.REACT_APP_ROOT_URL + route, {
                method: "POST",
                mode: "cors",

                headers: {
                    "Content-Type": "application/json"
                },
                
                body: JSON.stringify(obj)
            });

            if(!response.ok) {
                const err = await response.text();
                setError(err);
                throw new Error(err);
            }

            const {token} = await response.json();

            if(!token) throw new Error("No token provided");

            localStorage.setItem("course-tracker-token", token);

            await getUserInfo();

            setLoading(false);
            setIsLoggedIn(true);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }

    }

    const changeLoginType = () => {

        setEmail("");
        setPassword("");
        setName("");
        setError("");
        setLogin(!login);

    }

    return (
        <div id="loginContainer">
            <div id="loginRect">
                <div id="uuLogo" />

                <div id="formsContainer">
                    {
                        login ?
                            <form id="loginForm" className="form" onSubmit={logInFunc}>
                                <h2 className="formTitle">Login</h2>
                                {error && <p className="error">{error}</p>}
                                <input value={email} onChange={(e) => setEmail(e.target.value)} className="loginInput" type="email" placeholder="Email" required  disabled={loading}/>
                                <input value={password} onChange={(e) => setPassword(e.target.value)} className="loginInput" type="password" placeholder="Password" required  disabled={loading}/>
                                <button type="submit" className={"loginButton btn " + (loading ? "disabledBtn" : "") } disabled={loading}>Sign In</button>
                            </form>
                            :
                            <form id="signupForm" className="form" onSubmit={logInFunc}>
                                <h2 className="formTitle">Create an Account</h2>
                                {error && <p className="error">{error}</p>}
                                <input value={name} onChange={(e) => setName(e.target.value)} type="text" className="loginInput" placeholder="Name" required  disabled={loading}/>
                                <input value={email} onChange={(e) => setEmail(e.target.value)} className="loginInput" type="email" placeholder="Email" required  disabled={loading}/>
                                <input value={password} onChange={(e) => setPassword(e.target.value)} className="loginInput" type="password" placeholder="Password" required  disabled={loading}/>
                                <button type="submit" className={"loginButton " + (loading ? "disabledBtn" : "") } disabled={loading}>Sign Up</button>
                            </form>
                    }
                </div>
                <p id="switchButton" className="btn" onClick={changeLoginType} disabled={loading}>{login ? "Sign Up" : "Sign In"}</p>
            </div>
            <a id="copyrightTing" href="https://mochahadeh.github.io/" target="_blank" rel="noreferrer" className="btn">Mohamad Chahadeh, 200209366</a>
        </div>
    );
}